// extracted by mini-css-extract-plugin
export var dateTimeButton = "_dz-1";
export var dateTimeButtonsContainer = "_dz-6";
export var dateTimeInputContainer = "_dz-7";
export var dateTimeWrapper = "_dz-8";
export var disabledTile = "_dz-0";
export var header = "_dz-2";
export var line = "_dz-3";
export var snoozeOption = "_dz-4";
export var time = "_dz-5";
export var todayTile = "_dz-9";
export var wrapper = "_dz-a";